import {
  Component,
  OnInit,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef
} from "@angular/core";
import { MatRadioChange } from "@angular/material/radio";
import { Router } from "@angular/router";
import { Answer } from "../models/answer";
import { SaveSurveyCommand } from "../models/savesurveycommand";
import { SurveyQuestionVm } from "../models/surveyquestionVm";
//import { StateService } from "../services/state.service";
import { CacheService } from '../services/cache.service';
import { SurveyService } from "../services/survey.service";
import { CameraService } from '../services/camera.service';
import { SurveyInfo } from "../models/surveyinfo.model";
import { CountdownDialogComponent } from "../dialogs/countdown-dialog/countdown-dialog.component";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: 'app-msformsurvey',
  templateUrl: './msformsurvey.component.html',
  styleUrls: ['./msformsurvey.component.css']
})
export class MsformsurveyComponent implements OnInit {

  private _allQuestions: SurveyQuestionVm[] = [];
  private _pristineQuestions: SurveyQuestionVm[] = [];
  private _conditionalQuestions: SurveyQuestionVm[] = [];
  success: boolean = false;
  surveyEntryId: number;
  pdfUrl: string;
  public currentQuestion: any;
  visibleQuestions: SurveyQuestionVm[] = [];
  message: string = '';
  readerFileDetails: string = "";
  files: string[] = [];
  showPDF: boolean = true;
  surveyId: number;
  selectedSurveyInfo: SurveyInfo;
  surveyUrl: string;
  surveyCode: string;
  isSubmitting: boolean = false; 

  @Output() submitEvent: EventEmitter<string> = new EventEmitter<string>();
  @Output() hideWelcome = new EventEmitter<void>();
  @Input() set questions(value) {
    this._pristineQuestions = value;
    this._allQuestions = value;
    if (this._allQuestions) this._conditionalQuestions = this._allQuestions.filter(q => q.decisionFieldName != null);
  }

  get questions() {

    if (this._allQuestions == undefined) return [];
    if (this.currentQuestion == undefined) {
      this.visibleQuestions = this._allQuestions.filter(x => x.decisionFieldName == null);
      return this.visibleQuestions;
    }

    let conditionalQuestions: SurveyQuestionVm[] = this._allQuestions.filter((a) =>
      a.decisionFieldName == this.currentQuestion.questionFieldName &&
      a.decisionResponse.indexOf('|' + this.currentQuestion.answerText + '|') >= 0
    );

    //Reset answers for conditional questions if it was added from prior flow paths
    //conditionalQuestions.forEach(q=>q.answerText='');

    //remove conditional questions for currrent question 
    let quetionsAlreadyAdded = this.visibleQuestions.filter((q) => q.decisionFieldName == this.currentQuestion.questionFieldName);
    quetionsAlreadyAdded.forEach(qa => {
      if (qa.decisionResponse != this.currentQuestion.answerText) {
        this.visibleQuestions.splice(this.visibleQuestions.indexOf(qa), 1);
      }
    })

    //Remove conditional questions which don't have a parent
    this.visibleQuestions.filter(s => s.decisionFieldName != null).forEach(c => {
      let foundParent = this.visibleQuestions.some(q => q.questionFieldName == c.decisionFieldName);
      if (!foundParent) {
        this.visibleQuestions.splice(this.visibleQuestions.indexOf(c), 1);
      }
    });

    //Insert conditional questions if any
    if (conditionalQuestions.length > 0) {
      const found = this.visibleQuestions.some((r) => conditionalQuestions.includes(r));
      if (!found) {
        this.visibleQuestions.splice(this.visibleQuestions.indexOf(this.currentQuestion) + 1, 0, ...conditionalQuestions);
      }
    }
    const cachedData = this.cacheService.get('EMPRTW_Answers');
    if (cachedData) {
      this.visibleQuestions.forEach(q => {
        const mappedFieldName = this.mapQuestionFieldName(q.questionFieldName);

        console.log('mappedFieldName', mappedFieldName, q.questionFieldName, q.answerText);
        let answer = cachedData.items.find(a => a.questionFieldName === mappedFieldName);
        if (answer) {
          q.answerText = answer.answerText;
        }
      });
    }
  
    console.log('this.visibleQuestions', this.visibleQuestions);
    return this.visibleQuestions;
  }
  constructor(private dialog: MatDialog,
    private surveyService: SurveyService,
    private router: Router,
    private cameraService: CameraService,
    private cdRef: ChangeDetectorRef,
    private cacheService: CacheService
    //private stateService: StateService,
  ) { }

  async ngOnInit() {
    // for testing without submitting
    // this.success = true;
    // this.surveyEntryId = 1869702;
    // this.pdfUrl = '/api/reports/survey-pdf/'+this.surveyEntryId;
    //this.surveyUrl = this.route.snapshot.paramMap.get("url");
    //this.surveyUrl = this.router.url;

  }
  mapQuestionFieldName(questionFieldName: string): string {
    const mapping = {
      'RTWA_FirstName': 'EMPRTW_FirstName',
      'RTWA_LastName': 'EMPRTW_LastName',
      'RTWA_EmployeeId': 'EMPRTW_EmployeeId',
      'RTWA_Email': 'EMPRTW_Email',
      'RTWA_PhoneNumber': 'EMPRTW_PhoneNumber'
    };
    return mapping[questionFieldName] || questionFieldName;
  }

  onRadioChanged(currentQuestionEvent: any) {
    console.log(currentQuestionEvent);
    //if (!this._conditionalQuestions.includes(currentQuestionEvent)) {
    // this._conditionalQuestions.forEach(q => q.answerText = '');
    //}
    //else if (currentQuestionEvent.answerText !=="" ) {

    // this._conditionalQuestions.filter(a => a.answerText!='Yes').forEach(q => q.answerText = '');
    //}
    this.currentQuestion = currentQuestionEvent;
    const idx = this.visibleQuestions.findIndex(q => q.questionFieldName === currentQuestionEvent.questionFieldName);
    if (idx !== -1) {
      // Clear answers for all questions after the current one
      for (let i = idx + 1; i < this.visibleQuestions.length; i++) {
        this.visibleQuestions[i].answerText = '';
        if ('otherText' in this.visibleQuestions[i]) {
          this.visibleQuestions[i].otherText = '';
        }
      }
    }
  }

  ngAfterViewInit() { }

  loadExistingResponseById(headerId: number) {

  }

  changeFirstCharToLowerCase(fieldName: string): string {
    return fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
  }

  isFormInvalid() {
    let invaliddate = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "date")
      .some((q) => q.answerText == null || q.answerText.toString() == "");
    let invalidText = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "text")
      .some((q) => q.answerText == null || q.answerText.toString() == "");
    let invalidNumber = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "number")
      .some((q) => q.answerText == null || q.answerText.toString() == "");
    let invalidTextArea = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "textarea")
      .some((q) => q.answerText == null || q.answerText.toString() == "");

    let radioInvalid = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "radio")
      .some((q) => q.answerText == null || q.answerText.toString() == "");

    let phoneInvalid = this.visibleQuestions.filter(q => q.validations == 'PhoneNumber')
      .some(p => (new RegExp("^[0-9]{10}$|^[0-9\-]{12}$")).test(p.answerText) == false)

    let emailInvaild = this.visibleQuestions.filter(q => q.validations == 'Email')
      .some(p => (new RegExp("^.+@.+\..+$")).test(p.answerText) == false);

    let invaliddateOtherText = this.visibleQuestions
      .filter((q) => q.required == true && q.dataTypeName == "radio" && q.answerText == "Other - [UserText]")
      .some((q) => q.otherText == null || q.otherText.toString() == "");

    let fileUploadInvalid = this.visibleQuestions
      .filter((q) => q.required === true && q.dataTypeName === "extuploadinput")
      .some((q) => !this.isFileUploaded(q));
    console.log("Invalid states:", { invalidText, invaliddate, phoneInvalid, emailInvaild, radioInvalid, invaliddateOtherText, invalidTextArea, fileUploadInvalid, invalidNumber });  // Debugging
    return invalidText || invaliddate || phoneInvalid || emailInvaild || radioInvalid || invaliddateOtherText || invalidTextArea || fileUploadInvalid || invalidNumber;
  }

  isFileUploaded(question: any): boolean {
    return !!question.answerText;// && !string.IsNullOrEmpty(question.answerText);
  }

  get isFormReadyToSubmit() {

    return false;
  }
  get validationErrors() {
    let errorMessage = "";
    this.questions.forEach((q, index) => {
      if (q.answerText == "") {
        errorMessage += index + 1 + ", ";
      }
    });

    return errorMessage.length > 0 ? errorMessage + " Required" : errorMessage;
  }

  onFileSelected(fileData: string, question: any) {
    //question.answerText = fileData;
    this.readerFileDetails = fileData;
    console.log("File selected:", question);
    this.cdRef.detectChanges();
  }

  saveUploadImages(result, surveyEntryId) {
    this.files.push(result.toString());
    return this.cameraService.uploadRTWFile(this.files, surveyEntryId);
  }

  async submit() {

    this.hideWelcome.emit();
    let saveEntryData: SaveSurveyCommand = new SaveSurveyCommand();

    saveEntryData.surveyAppId = this.questions[0].surveyAppId;
    this.surveyCode = this.questions[0].surveyCode;

    let answers: Answer[] = [];
    this.questions.forEach((q) => {
      let tempAnswer: Answer = new Answer();
      tempAnswer.questionFieldName = q.questionFieldName;
      tempAnswer.answerText = q.answerText == "Other - [UserText]" ? q.otherText : q.answerText;
      answers.push(tempAnswer);
    });

    saveEntryData.items = answers;
    saveEntryData.surveyCode = this.surveyCode;

    console.log(saveEntryData);

    this.isSubmitting = true;

    this.message = 'Thank you for your submission.';
    if (saveEntryData.items.find(answer => answer.questionFieldName === "EMPRTW_ReturnFrom"
      && answer.answerText === 'Military, or FMLA leave associated with Parental/Bonding (non-maternal delivery leave or Care of a family member)')) {
      this.message = '<div style="background-color: red; color: white; padding: 10px; border-radius: 5px;">Your request is being assigned to the Leave Team for follow up. Please contact your leader about your intent to return to work. </div>`';
    }
    else if (saveEntryData.items.find(answer => answer.questionFieldName === "EMPRTW_NHCriteria"
      && answer.answerText === 'No')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Please return to this form when you meet the EOH return to work guidelines and/or have clearance from your healthcare provider to return to work. If you have a need for a continued absence/leave, please contact the Hartford at 888-277-4767.</div>`';
    }
    else if (saveEntryData.items.find(answer => answer.questionFieldName === "EMPRTW_WorkScenerio"
      && answer.answerText === 'I have been out of work less than 5 calendar days, do not have an infectious illness or symptoms of infectious illness (fever, diarrhea, vomiting, rash), or am not returning to work with any new work restrictions (including assistive devices) or accommodation needs and am able to complete the essential functions of my job.')) {
      this.message = '<div style="background-color: green; color: white; padding: 10px; border-radius: 5px;">EOH Clearance is not required, you can return to work.</div>`';
    }

    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "RTWA_IllnessGuidelines")
      && answer.answerText === 'No')) {
      this.message = '<div style="background-color: red; color: white; padding: 10px; border-radius: 5px;">Based on your answers you are not eligible for return to work at this time and should restart the return to work process once you have met all of the infectious illness criteria to return to work.</div>`';

    }
    else if (saveEntryData.items.find(answer => (
     answer.questionFieldName === "RTWA_EssentialFunctions"
      || answer.questionFieldName === "RTWA_MeetGuideLines")
      && answer.answerText === 'No')) {
      this.message = '<div style="background-color: red; color: white; padding: 10px; border-radius: 5px;">Based on your answers you are not eligible for auto return to work clearance and should restart the return to work process and should carefully review all questions and your responses so that you can be directed to the appropriate team for return to work.</div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "RTWA_EssentialFunctions"
      || answer.questionFieldName === "RTWA_MeetGuideLines"
      || answer.questionFieldName === "RTWA_IllnessGuidelines"))) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">You are cleared to return to work immediately. Confirmation of clearance to return to work will be sent to the emails that you provided.</div>`';

    }

    //else if (saveEntryData.items.find(answer => answer.questionFieldName === "EMPRTW_UploadDocument"
    //  && answer.answerText !== null && answer.answerText !== undefined)) {
    //  this.message = '<div style="background-color: red; color: white; padding: 10px; border-radius: 5px;">Your return to work request has been received, you will be contacted at the contact phone number and/or email provided regarding next steps.</div>`';
    //}
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_SituationDescY")
      && answer.answerText === 'Returning to work with no restrictions or restrictions that are for less than 4 weeks')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. Employee Health hours are Monday – Friday 7: 30 am – 4:00 pm </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_SituationDescY")
      && answer.answerText === 'Returning to work with restrictions that last more than 4 weeks')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_InfectiousSymptoms")
      && answer.answerText === 'Yes')) {
      this.message = '<div style="background-color: red; color: white; padding: 10px; border-radius: 5px;">You are NOT cleared, please complete the return to work app when you are symptom free. </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_SituationDescN")
      && answer.answerText === 'Out of work greater than 5 days (with or without restrictions)')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. Employee Health hours are Monday – Friday 7: 30 am – 4:00 pm </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_SituationDescN")
      && answer.answerText === 'Out of work less than 5 days and no restrictions')) {
      this.message = '<div style="background-color: green; color: white; padding: 10px; border-radius: 5px;">EOH Clearance is not required, you can return to work. </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_ReturningRestrictions")
      && answer.answerText === 'No')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. Employee Health hours are Monday – Friday 7: 30 am – 4:00 pm </div>`';

    }

    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_PermanentRestrictions")
      && answer.answerText === 'Yes')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_OutWork")
      && answer.answerText === 'Yes')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. Employee Health hours are Monday – Friday 7: 30 am – 4:00 pm </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_Covid10days")
      && answer.answerText === 'Yes')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. Employee Health hours are Monday – Friday 7: 30 am – 4:00 pm </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_OutWork")
      && answer.answerText === 'No')) {
      this.message = '<div style="background-color: green; color: white; padding: 10px; border-radius: 5px;">EOH Clearance is not required, you can return to work. </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_DescRestriction")
      && answer.answerText === 'Your restrictions last more than 4 weeks')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_DescRestriction")
      && answer.answerText === 'Your restrictions last less than 4 weeks')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request has been received, you will be contacted within 2 business days for next steps. Employee Health hours are Monday – Friday 7: 30 am – 4:00 pm </div>`';

    }
    else if (saveEntryData.items.find(answer => (
      answer.questionFieldName === "EMPRTW_OutReason")
      && answer.answerText === 'Military Leave, Parental Leave, or Care of a Family Member Leave')) {
      this.message = '<div style="background-color: orange; color: white; padding: 10px; border-radius: 5px;">Your request is being assigned to the Leave Team for follow up. Please also contact your leader about your intent to return to work.</div>`';

    }

    this.surveyService.saveSurvey(saveEntryData).subscribe(
      (responseData) => {
        //success
        console.log('responseData', responseData);
        this.surveyEntryId = responseData;
        this.pdfUrl = '/s/api/survey/survey-pdf/' + this.surveyEntryId;
        this.isSubmitting = false;
        this.success = true;
        if (saveEntryData.surveyCode == 'EMPRTW' && saveEntryData.items.find(answer => answer.questionFieldName === "EMPRTW_UploadDocument"
          && answer.answerText !== null && answer.answerText !== undefined)) {
          this.saveUploadImages(this.readerFileDetails, this.surveyEntryId).toPromise();
        }
        if (this.router.url.indexOf('covid-exposure-intake-queue') > -1) {
          let eohDeterminationQuestion = this.questions.find(q => q.questionFieldName == 'EOHDetermination');
          if (eohDeterminationQuestion != undefined)
            this.submitEvent.emit(eohDeterminationQuestion.answerText)
        }
        if (saveEntryData.surveyCode === 'EMPRTW' && saveEntryData.items.find(answer => answer.questionFieldName === "EMPRTW_WorkScenerio"
          && answer.answerText === 'I was diagnosed with an infectious illness or had infectious illness symptoms (fever, diarrhea, vomiting, rash) and <b>I am not requesting coverage under the infectious illness period as outlined in the NH attendance policy.</b>')) {
          // Redirect to the Return to Work Acknowledgement component

      

          const dialogRef = this.dialog.open(CountdownDialogComponent, {
            width: '1000px',
            disableClose: true,
            data: {}
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              this.cacheService.set('EMPRTW_Answers', saveEntryData);
              console.log('responseDataTestForCache', saveEntryData);
              this.router.navigate(['/return-to-work-acknowledgement']);
            }
          });
          return;
        }
        //this.router.navigate(["/thank-you"]);
      },
      (error) => {
        console.error(error);
        this.isSubmitting = false;
      }
    );
  }
}
